import { render, staticRenderFns } from "./DownlinkEditor.vue?vue&type=template&id=b1c3a1a2"
import script from "./DownlinkEditor.vue?vue&type=script&lang=js"
export * from "./DownlinkEditor.vue?vue&type=script&lang=js"
import style0 from "./DownlinkEditor.vue?vue&type=style&index=0&id=b1c3a1a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports